function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(2.745098%,2.745098%,4.313725%)",
      fillOpacity: 1
    },
    d: "M 32 16 C 32 24.835938 24.835938 32 16 32 C 7.164062 32 0 24.835938 0 16 C 0 7.164062 7.164062 0 16 0 C 24.835938 0 32 7.164062 32 16 Z M 32 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 21.386719 8.039062 C 20.464844 8.039062 19.585938 8.40625 18.933594 9.066406 C 18.28125 9.726562 17.914062 10.617188 17.914062 11.546875 L 13.734375 11.546875 L 17.199219 8.039062 L 12.972656 8.039062 C 12.054688 8.039062 11.171875 8.40625 10.519531 9.066406 C 9.871094 9.726562 9.503906 10.617188 9.507812 11.546875 L 9.464844 11.546875 C 8.546875 11.546875 7.667969 11.914062 7.011719 12.574219 C 6.363281 13.234375 6 14.125 6 15.054688 L 9.507812 15.054688 L 9.507812 17.671875 C 9.492188 21.144531 12.289062 23.972656 15.761719 24 L 22.132812 24 L 22.140625 11.507812 L 25.605469 8 Z M 17.753906 17.308594 C 17.371094 16.925781 17.257812 16.351562 17.464844 15.851562 C 17.535156 15.6875 17.632812 15.539062 17.753906 15.414062 L 19.625 17.308594 C 19.25 17.6875 18.683594 17.800781 18.1875 17.601562 C 18.019531 17.535156 17.878906 17.433594 17.753906 17.308594 Z M 17.753906 17.308594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitebit);
export default __webpack_public_path__ + "static/media/whitebit.9803784b.svg";
export { ForwardRef as ReactComponent };